import { alertActions } from "./alert.actions";
import { chartConstants } from "../_constants";
import { chartService } from "../_services";
import { campaignActions } from "./campaign.actions";

export const chartActions = {
    getCharts
};

function getCharts(filter) {
    return dispatch => {
        dispatch(request());
        dispatch(campaignActions.checkUpdate(1))
        dispatch(alertActions.loading("Loading...."));

        chartService.getCharts(filter).then(
            chart => {
                if (chart.name === "AbortError") {
                    // dispatch(alertActions.clear());
                } else {
                    if (chart.bydate && chart.bydate.data && chart.byhour && chart.byhour.data && chart.byarea && chart.byarea.data) {
                        dispatch(success(chart));
                        dispatch(alertActions.clear());
                    } else {
                        dispatch(success({ data: [] }));
                        dispatch(alertActions.success("No data"));
                    }
                }
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error.message));
            }
        );
    };

    function request() {
        return { type: chartConstants.GETALL_REQUEST };
    }

    function success(chart) {
        return { type: chartConstants.GETALL_SUCCESS, chart };
    }

    function failure(error) {
        return { type: chartConstants.GETALL_FAILURE, error };
    }
}



// WEBPACK FOOTER //
// ./src/_actions/chart.actions.js